export default {
  shanxi: {
    getGvOpenNumber_params_multiply: 5
  },
  hebei: {
    getGvOpenNumber_params_multiply: 5
  },
  rrt: {
    getGvOpenNumber_params_multiply: 5000
  },
  liaoning: {
    getGvOpenNumber_params_multiply: 5000
  }
}
